export class videoModel {
    id: number;
    filePath: string;
    displayName: string;
}

export const VIDEOS: videoModel[] = [
    {
        id: 1,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Activating_and_Deactivating_LUCA_AI.mp4',
        displayName: 'Activate/Deactivate Luca'
    },
    {
        id: 2,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Exploring_Luca_window.mp4',
        displayName: "Exploring Luca's actions on window"
    },
    {
        id: 3,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Conversing_with_Luca_AI.mp4',
        displayName: "Chat History Window"
    },
    {
        id: 4,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Uploading_a_document.mp4',
        displayName: "Document Upload"
    },
    {
        id: 5,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Actions_on_Luca_response.mp4',
        displayName: "Download/Save Files from Luca"
    },
    {
        id: 6,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Variance_analysis.mp4',
        displayName: "Variance Analysis Prompt"
    },
    {
        id: 7,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Aged_AR_Analysis.mp4',
        displayName: "Aged AR Analysis Prompt"
    },
    {
        id: 8,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Investment_analysis.mp4',
        displayName: "Investment Schedule Prompt"
    },
    {
        id: 9,
        filePath: 'https://adinovis-assets.s3.us-east-2.amazonaws.com/Luca/Context_window_in_Luca_AI.mp4',
        displayName: "Context Selection"
    }
];